import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MsalService } from "@azure/msal-angular";

import { environment } from "src/environments/environment";
import { AppSpinnerModule } from "../shared/modules/app-spinner.module";

@Component({
  selector: "app-registration-redirect",
  template: "",
})
export class RegistrationRedirectComponent implements OnInit {
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: MsalService,
    private readonly spinner: AppSpinnerModule,
  ) {}

  ngOnInit() {
    this.spinner.show();
    const params = this.activatedRoute.snapshot.queryParams;

    this.authService.loginRedirect({
      authority: environment.azureB2C.registrationAuthority,
      extraQueryParameters: { id: params.id },
      scopes: [environment.apiScope],
    });
  }
}
